namespace TabAurous.OMS {
    export interface ProcessMasterRow {
        ProcessId?: number;
        ProcessCode?: string;
        ProcessName?: string;
        ItemTypeId?: number;
        CalcOnId?: number;
        ProcessTypeId?: number;
        FixedName?: string;
        IsDisabled?: boolean;
        SysParam?: boolean;
        QualityInspectionId?: number;
        ProcessApplicableDetails?: number[];
        InspectionDetails?: ProcessInspectionRow[];
        CalculateTo?: Common.CalculateTo;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
        IsSetting?: boolean;
    }

    export namespace ProcessMasterRow {
        export const idProperty = 'ProcessId';
        export const nameProperty = 'ProcessCode';
        export const localTextPrefix = 'OMS.ProcessMaster';
        export const lookupKey = 'OMS.ProcessMaster';

        export function getLookup(): Q.Lookup<ProcessMasterRow> {
            return Q.getLookup<ProcessMasterRow>('OMS.ProcessMaster');
        }
        export const deletePermission = 'Masters:ProcessMaster:Delete';
        export const insertPermission = 'Masters:ProcessMaster:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:ProcessMaster:Edit';

        export declare const enum Fields {
            ProcessId = "ProcessId",
            ProcessCode = "ProcessCode",
            ProcessName = "ProcessName",
            ItemTypeId = "ItemTypeId",
            CalcOnId = "CalcOnId",
            ProcessTypeId = "ProcessTypeId",
            FixedName = "FixedName",
            IsDisabled = "IsDisabled",
            SysParam = "SysParam",
            QualityInspectionId = "QualityInspectionId",
            ProcessApplicableDetails = "ProcessApplicableDetails",
            InspectionDetails = "InspectionDetails",
            CalculateTo = "CalculateTo",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date",
            IsSetting = "IsSetting"
        }
    }
}
